import React from "react";
import { Table, Button, Glyphicon } from "react-bootstrap";
import NoRecords from "./NoRecords";

const ActionButtons = ({ actions, recordId }) =>
  actions.map((action, idx) => (
    <span key={idx}>
      &nbsp;
      <Button
        id={action.id + "-" + recordId}
        disabled={action.disabled ? action.disabled(recordId) : false}
        onClick={event => {
          event.preventDefault();
          action.onClick && action.onClick(recordId);
        }}
        className={action.className}
        href={action.href && action.href(recordId)}
      >
        {action.glyph && <Glyphicon glyph={action.glyph} />}
        {action.text}
      </Button>
    </span>
  ));

const tdProps = column => (column.tdProps ? column.tdProps : {});

export const Row = ({
  tableId,
  rowData,
  columns,
  actions,
  identityProperty,
  rowIndex,
}) => {
  const recordId = rowData[identityProperty];
  const dataCells = columns.map((column, idx) => {
    // data(rowData) is mandatory: We're ok with the crash if it is not provided or it is not a function
    const data = column.data(rowData);
    // badges(rowData) is optional: We avoid a crash if not provided. We're ok with the crash if it is provided but is not a fuction
    const badges = column.badges && column.badges(rowData);
    return (
      <td
        id={`${tableId}-col-${idx}-record-${rowIndex}`}
        key={idx}
        {...tdProps(column)}
      >
        {data}
        {badges}
      </td>
    );
  });
  const actionCell = (
    <td>
      <div className="pull-right" style={{ whiteSpace: "nowrap" }}>
        <ActionButtons actions={actions} recordId={recordId} />
      </div>
    </td>
  );
  return (
    <tr>
      {dataCells}
      {actionCell}
    </tr>
  );
};

const THead = ({ columns }) => {
  const dataCells = columns.map((column, idx) => (
    <th key={idx} {...tdProps(column)}>
      {column.header}
    </th>
  ));

  return (
    <tr>
      {dataCells}
      <th className="text-right" />
    </tr>
  );
};

export default ({
  id,
  data,
  columns,
  actions,
  identityProperty,
  noDataMessage,
  loading,
  loadingMessage,
}) => {
  const headerLines = <THead columns={columns} />;

  const dataLines = loading ? (
    <NoRecords
      tableId={id}
      colSpan={columns.length + 1}
      message={loadingMessage}
    />
  ) : (
    data.map((rowData, idx) => (
      <Row
        key={idx}
        rowIndex={idx}
        tableId={id}
        rowData={rowData}
        columns={columns}
        actions={actions}
        identityProperty={identityProperty}
      />
    ))
  );

  const tableLines =
    !loading && data.length === 0 ? (
      <NoRecords
        tableId={id}
        colSpan={columns.length + 1}
        message={noDataMessage}
      />
    ) : (
      dataLines
    );

  return (
    <div>
      <Table id={id} striped responsive condensed hover>
        <thead>{headerLines}</thead>
        <tbody>{tableLines}</tbody>
      </Table>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/sc/ui/components/Table.js